import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, Phrase } from "@neru/ui";
import { useCurrentAccount } from "../../hooks";
export var TierUpdatedAnnouncement = function() {
    var tier = useCurrentAccount().tier;
    if (!(tier === null || tier === void 0 ? void 0 : tier.name)) {
        return;
    }
    return /*#__PURE__*/ _jsxs(Phrase, {
        "data-testid": "plan-change-announcement",
        children: [
            /*#__PURE__*/ _jsx(Icon, {
                className: "mr-1",
                connotation: "announcement",
                size: "small",
                type: "check-circle-solid"
            }),
            " ",
            "Your plan has been updated to ",
            /*#__PURE__*/ _jsx("strong", {
                children: tier === null || tier === void 0 ? void 0 : tier.name
            }),
            "."
        ]
    });
};

//# sourceMappingURL=TierUpdatedAnnouncement.js.map